import { ReactComponent as CourtIcon } from '@/assets/icons/ri-badminton-court.svg';

const DAYS = [
	{ label: 'Monday', value: '1' },
	{ label: 'Tuesday', value: '2' },
	{ label: 'Wednesday', value: '3' },
	{ label: 'Thursday', value: '4' },
	{ label: 'Friday', value: '5' },
	{ label: 'Saturday', value: '6' },
	{ label: 'Sunday', value: '0' }
]

const courtData = (courts: { [key: string]: any }[]) => {
	const bookedCourts = {};
	courts.forEach((court) => {
		if (bookedCourts[court.venue_court_id]) {
			bookedCourts[court.venue_court_id].push(court);
		} else {
			bookedCourts[court.venue_court_id] = [{ ...court }];
		}
	});
	return bookedCourts;
};

const formatBookingHours = (
	hours: number[]
): { [key: string]: { start: number; end: number; duration: number } } => {
	const bookedHours = {};
	hours.sort((a, b) => a - b);
	let start = 0;
	let end = 0;
	let duration = 0;
	hours.forEach((hour) => {
		if (hour === end) {
			end += 1;
			duration += 1;
			bookedHours[start].end = end;
			bookedHours[start].duration = duration;
		} else {
			start = hour;
			end = hour + 1;
			duration = 1;
			bookedHours[start] = {
				start,
				end,
				duration,
			};
		}
	});
	return bookedHours;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Schedule = ({ summary, venues }): any => (
	<div className="flex flex-col p-0 gap-4">
		{Object.keys(summary).map((date) => {
			const courts = courtData(summary[date]);
			return (
				<div className="flex flex-col p-0 gap-4">
					<div className="flex flex-col py-2 gap-2 bg-grey-subtle">
						<div className="flex pl-2 gap-2">
							<p className="font-medium text-xs">{DAYS.find(day => day.value === date).label}</p>
						</div>
						<div className="flex border-b border-grey-line-subtle" />
					</div>
					{Object.keys(courts).map((courtId) => {
						const hours = formatBookingHours(
							courts[courtId].map((booking) => booking.start_time)
						);
						return (
							<div className="flex flex-col px-2 gap-2">
								<div className="flex items-center gap-4 p-0">
									<div className="flex flex-col justify-center items-center px-3 py-4 gap-2 bg-green-success rounded text-white">
										<CourtIcon />
									</div>
									<div className="flex flex-col">
										<p className="font-medium text-sm">
											{
												venues?.courts?.find(
													(court) => court.id === courtId
												)?.code
											}
										</p>
										{Object.values(hours).map((hour) => {
											const { start, end } = hour;
											return (
												<p className="text-xs text-grey-dark">
													{`${start}.00 - ${end}.00 WIB`}
												</p>
											);
										})}
									</div>
								</div>
							</div>
						);
					})}
				</div>
			);
		})}
	</div>
);
export default Schedule;
